module.exports = __webpack_public_path__ + "img/hr-pipe-to-ground-up.92c990e9.png";